import React from "react";
import ReactDOM from "react-dom/client";

import {DeveloperMarketing} from "./views/DeveloperMarketing";

import "./styles/styles.css";

const rootElement = document.getElementById("root")!;
const root = ReactDOM.createRoot(rootElement);

root.render(
    <React.StrictMode>
        <DeveloperMarketing />
    </React.StrictMode>
);
import React from "react";
import ReactDOM from "react-dom/client";

import {DeveloperMarketing} from "./views/DeveloperMarketing";

import "./styles/styles.css";

const rootElement = document.getElementById("root")!;
const root = ReactDOM.createRoot(rootElement);

root.render(
    <React.StrictMode>
        <DeveloperMarketing />
    </React.StrictMode>
);
